import { render, staticRenderFns } from "./OptionsSceneDataImportExport.vue?vue&type=template&id=49452536&"
import script from "./OptionsSceneDataImportExport.vue?vue&type=script&lang=js&"
export * from "./OptionsSceneDataImportExport.vue?vue&type=script&lang=js&"
import style0 from "./OptionsSceneDataImportExport.vue?vue&type=style&index=0&id=49452536&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports